import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { TestResultsArtifact } from '../types';
interface Props {
  artifact: TestResultsArtifact;
  breadcrumb?: string;
  onViewInSession?: () => void;
}
export function TestResultsCard({
  artifact,
  breadcrumb,
  onViewInSession
}: Props) {
  const allPassed = artifact.failed === 0;
  return <div className="bg-[#1c1c22] rounded-[16px] border border-white/[0.04] overflow-hidden" data-id="element-512">
      {breadcrumb && <div className="px-4 pt-3 text-[11px] text-[#8a8680]/60 tracking-wide" data-id="element-513">{breadcrumb}</div>}
      <div className="flex items-center gap-2 px-4 pt-3 pb-2" data-id="element-514">
        {allPassed ? <CheckCircle2 size={14} className="text-[#4a9a9a]" strokeWidth={1.5} data-id="element-515" /> : <XCircle size={14} className="text-[#e8a84c]" strokeWidth={1.5} data-id="element-516" />}
        <span className={`text-[11px] uppercase tracking-wide ${allPassed ? 'text-[#4a9a9a]' : 'text-[#e8a84c]'}`} data-id="element-517">
          Test results
        </span>
        <span className="text-[11px] text-[#8a8680]/60 ml-auto" data-id="element-518">{artifact.timestamp}</span>
      </div>
      <div className="px-4 pb-4" data-id="element-519">
        <h3 className="text-[14px] text-[#e8e4df] mb-2" data-id="element-520">{artifact.title}</h3>
        <div className="flex items-center gap-4 text-[12px] mb-3" data-id="element-521">
          <span className="text-[#4a9a9a]" data-id="element-522">{artifact.passed} passed</span>
          {artifact.failed > 0 && <span className="text-[#e8a84c]" data-id="element-523">{artifact.failed} failed</span>}
        </div>
        {artifact.failingTests.length > 0 && <div className="space-y-2" data-id="element-524">
            {artifact.failingTests.map(t => <div key={t.name} className="bg-white/[0.02] rounded-[10px] px-3 py-2" data-id="element-525">
                <div className="text-[12px] text-[#e8e4df] font-mono" data-id="element-526">{t.name}</div>
                <div className="text-[11px] text-[#8a8680] font-mono mt-1" data-id="element-527">{t.error}</div>
              </div>)}
          </div>}
        {onViewInSession && <button onClick={onViewInSession} className="mt-3 text-[11px] text-[#8a8680] hover:text-[#4a9a9a] transition-colors" data-id="element-528">
            View in session →
          </button>}
      </div>
    </div>;
}